
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { BusinessService } from '@mpt-fo/common/core/services/business.service';
import { ProfileService } from '@mpt-fo/common/core/services/profile.service';
import { ScreenManagerService } from '@mpt-fo/common/core/services/screen-manager.service';
import { ModalService } from '@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service';
import { DialogMessageType } from '@mpt-fo/common/shared/models/utility.model';
import { BusinessPinComponent } from '../../business-pin.component';

@Component({
  selector: 'app-business-pin-desktop',
  templateUrl: './business-pin-desktop.component.html',
  styleUrls: ['./business-pin-desktop.component.scss']
})
export class BusinessPinDesktopComponent extends BusinessPinComponent implements OnInit {

  mobileMessageType: DialogMessageType;
  constructor(screenManager: ScreenManagerService, fb: FormBuilder, router: Router, businessService: BusinessService, profileService: ProfileService, modalService: ModalService) {
    super(screenManager, fb, router, businessService, profileService, modalService)

  }

  ngOnInit(): void {
		super.ngOnInit();
		this.initialize();
  }
  // submit() {
  //   const config = this.createModalConfig();
  //   this.runningModal = this.modalService.createModal(
  //     PinMessageComponent,
  //     config
  //   );
  //   this.runningModal.afterClose.asObservable().subscribe((data) => {
  //   })
  // }

	// createModalConfig() {
	// 	const config = new ModalOptionsConfig();
	// 	config.className = 'moniepoint-dialog';
	// 	config.nzWidth = 396;
	// 	config.nzComponentParams.callback = (result) => {
	// 		this.closeModal();
	// 	};
	// 	return config;
	// }

  // closeModal() {
	// 	this.runningModal.destroy();
	// }

}
